export default __webpack_public_path__ + "static/media/tiktok.16ae5d8b.webp";